import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-item-title" }

import { computed } from 'vue';
import { useStore } from 'vuex';
import secondsToMilliseconds from 'date-fns/secondsToMilliseconds';
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import useOpenCard from '@/utilities/composables/useOpenCard';
import useTranslate from '@/utilities/composables/useTranslate';
import { getCardStatus } from '@/utilities/defaultCardStatuses';
import { ResourceType } from '@/types/resources';
import cardStatusType from '@/types/cardStatusType';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarCardItem',
  props: {
  card: {
    type: Object,
    required: true,
  },
  // weekId - timestamp of the week
  weekId: {
    type: Number,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  maxCardsVisible: {
    type: Number,
    required: true,
  },
  inTooltip: {
    type: Boolean,
    default: false,
  },
},
  emits: ['open-card'],
  setup(__props, { emit: __emit }) {

const store = useStore();
const { iconPath, getCustomIconStyle } = useCustomIcon();
const { openCard } = useOpenCard();
const { translate } = useTranslate();

const props = __props;

const emit = __emit;

const card = computed(() => props.card.calendarTask);
const croppedEdges = computed(() => props.card.croppedEdges);
const style = computed(() => props.card.style);

const cardStartDate = computed(() => secondsToMilliseconds(card.value.start_date));
const cardEndDate = computed(() => secondsToMilliseconds(card.value.due_date));

const areCardDatesSet = computed(() => !!(cardStartDate.value && cardEndDate.value));

const isRightEdgeCropped = computed(() => {
  return croppedEdges.value.has('right');
});

const isLeftEdgeCropped = computed(() => {
  return croppedEdges.value.has('left');
});

const isDueDateBeforeStartDate = computed(() => {
  return cardEndDate.value < cardStartDate.value && areCardDatesSet.value;
});

const cardStyle = computed(() => ({
  ...style.value,
}));

const statusIcon = computed(() => {
  const isEpic = card.value.type === ResourceType.Epic;
  return (
    getCardStatus(card.value.status, isEpic)?.icon ||
    getCardStatus(cardStatusType.Backlog, isEpic).icon
  );
});

const lists = computed(() => store.getters.lists);

const statusColor = computed(() => {
  return (
    lists.value[card.value.list_id]?.color ||
    card.value.list_color ||
    getCardStatus(card.value.status)?.color ||
    getCardStatus(cardStatusType.Backlog).color
  );
});

const cardStatusStyle = computed(() => ({
  ...getCustomIconStyle(iconPath(statusIcon.value)),
  backgroundColor: statusColor.value,
}));

const cardList = computed(() => {
  return store.getters.lists[card.value.list_id] || {};
});

const statusTooltipText = computed(() => card.value.list_title || cardList.value.title || '');

const handleCardClick = () => {
  emit('open-card');
  openCard(card.value);
};

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["calendar-card-item", {
      'left-edge-cropped': isLeftEdgeCropped.value,
      'right-edge-cropped': isRightEdgeCropped.value,
      'due-before-start': isDueDateBeforeStartDate.value,
    }]),
    style: _normalizeStyle(cardStyle.value),
    onClick: handleCardClick
  }, [
    _withDirectives(_createElementVNode("em", {
      class: "custom-icons calendar-card-status",
      style: _normalizeStyle(cardStatusStyle.value)
    }, null, 4), [
      [_directive_tooltip, {
        content: statusTooltipText.value,
        placement: 'top-start',
        onShow: () => !!statusTooltipText.value && !_ctx.isMobile,
      }]
    ]),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createElementVNode("div", _hoisted_1, _toDisplayString(card.value.title), 1)
  ], 6)), [
    [_directive_tooltip, {
      content: _unref(translate)('endDateIsBeforeStartDate'),
      placement: 'top',
      onShow: () => isDueDateBeforeStartDate.value && !_ctx.isMobile,
    }]
  ])
}
}

})